<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,

        props: {
            dateRanges: {
                type: Object,
                required: true
            }
        },

        data: () => ({
            loading: false,
            chartdata: {
                labels: [],
                datasets: [
                    {
                        label: 'Top 10 ลูกค้าที่แลกมากที่สุด',
                        backgroundColor: '#f87979',
                        data: []
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false
            }
        }),

        watch: {
            dateRanges: {
                deep: true,
                handler({fromDate, toDate}) {
                    this.load({fromDate, toDate})
                }
            }
        },

        async mounted () {
            try {
                await this.load(this.$props.dateRanges)
            } catch (e) {

            }
        },

        methods: {
            async load({fromDate, toDate}) {
                this.loading = true

                try {
                    const { data } = await axios.get(`/reports/top-customers`, {
                        params: {
                            from_date: fromDate,
                            to_date: toDate
                        }
                    })

                    const labels = [];
                    const items = [];

                    data.data.forEach((customer) => {
                        labels.push(customer.customer_name)
                        items.push(customer.sum_g)
                    })

                    this.chartdata.labels = labels
                    this.chartdata.datasets[0].data = items

                    this.renderChart(this.chartdata, this.options)

                } catch (e) {
                    //
                }

                this.loading = false
            }
        }
    }
</script>
